export const ROW_KEY_ATTRIBUTE_NAME = "data-rowkey";
export const TABLE_BODY_ROW_CLASS = "wf-table__row";
export const TABLE_BODY_CELL_CLASS = "wf-table__cell";